import React, { useMemo } from 'react';
import { Autocomplete, Box, Chip, TextField } from '@mui/material';
import { getSkillChipSx } from './skillChipStyles';

type SkillSectionProps = {
  label: string;
  placeholder: string;
  value: string[];
  savedSkills: string[];
  onChange: (value: string[]) => void;
};

export const SkillSection: React.FC<SkillSectionProps> = ({
  label,
  placeholder,
  value,
  savedSkills,
  onChange
}) => {
  const savedSet = useMemo(() => new Set(savedSkills), [savedSkills]);

  return (
    <Box className="cv-skills-review__section">
      <h4 className="cv-skills-review__section-title">{label}</h4>
      <Autocomplete
        multiple
        freeSolo
        options={[]}
        value={value}
        onChange={(_event, newValue) => onChange(newValue as string[])}
        className="skills-autocomplete"
        renderTags={(tags, getTagProps) =>
          tags.map((option, index) => {
            const isSaved = savedSet.has(option);
            return (
              <Chip
                label={option}
                {...getTagProps({ index })}
                key={`${option}-${index}`}
                sx={getSkillChipSx(isSaved)}
              />
            );
          })
        }
        renderInput={(params) => (
          <TextField
            className="skills-autocomplete"
            {...params}
            variant="outlined"
            placeholder={placeholder}
          />
        )}
      />
    </Box>
  );
};
